import { RestHandler, MockedRequest, DefaultRequestBody, rest } from 'msw';
import { DB } from '../db';

const routes: RestHandler<MockedRequest<DefaultRequestBody>>[] = [];

routes.push(
    /**
     * GET /procedures/templates
     * Gets all procedure templates for a firm
     */
    rest.get('/procedures/templates', (req, res, ctx) => {
        const procedureTemplates = DB.GetProcedureTemplates();

        return res(ctx.delay(), ctx.status(200), ctx.json({ procedureTemplates, totalItems: procedureTemplates.length }));
    })
);

export { routes };
